import AttachmentViewState from '../schema/AttachmentViewState';
import { action } from 'satcheljs/lib/legacy';

export default action('setPreviewLoaded')(function setPreviewLoaded(
    attachment: AttachmentViewState,
    newValue: boolean
): void {
    attachment.previewLoaded = newValue;
});
